//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BendAngle",0,"Expression",0],[1,"BendRadius",0,"Expression",0],[0,"CircularSegments",1,0],[0,"FalloffPercentage",1,0],[1,"Height",0,"Expression",0],[0,"LinearSegments",1,0],[1,"MeshBodies",0,"SelectNXObjectList",0],[1,"PivotPointLocation",0,"Expression",0],[1,"Size",0,"Expression",0],[1,"Transformer",0,"GeometricUtilities.TransformerData",0],[1,"TwistAngle",0,"Expression",0],[0,"Type",1,0]],[[[],"Enable",{},0,0],[[],"ResetToCage",{},0,0],[[],"UpdateCageAndBody",{},0,0]],[]];
SPLM.Features.MorphMeshTwistBendData = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MorphMeshTwistBendData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MorphMeshTwistBendData.Types = Object.freeze({
    "Cage" : "Cage", "CageAndBody" : "CageAndBody"});

export default SPLM;